import type { SVGProps } from 'react';

const Genre = (props: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3Z"
            fill="currentColor"
        />
        <path
            d="M7 4C7.55228 4 8 3.55228 8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4Z"
            fill="currentColor"
        />
        <path
            d="M8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7Z"
            fill="currentColor"
        />
        <path
            d="M3 8C3.55228 8 4 7.55228 4 7C4 6.44772 3.55228 6 3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 1C0 0.447716 0.447715 0 1 0H9C9.55228 0 10 0.447715 10 1V9C10 9.55228 9.55229 10 9 10H1C0.447716 10 0 9.55229 0 9V1ZM1 1H9V9H1V1Z"
            fill="currentColor"
        />
        <path
            d="M11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8H15V15H8V11.5C8 11.2239 7.77614 11 7.5 11C7.22386 11 7 11.2239 7 11.5V15C7 15.5523 7.44772 16 8 16H15C15.5523 16 16 15.5523 16 15V8C16 7.44772 15.5523 7 15 7H11.5Z"
            fill="currentColor"
        />
        <path
            d="M13 11C13.5523 11 14 10.5523 14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10C12 10.5523 12.4477 11 13 11Z"
            fill="currentColor"
        />
        <path
            d="M11 13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13C9 12.4477 9.44771 12 10 12C10.5523 12 11 12.4477 11 13Z"
            fill="currentColor"
        />
    </svg>
);

export default Genre;
